"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTrainingOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 3.9L.64 11.07 7 14v9.51l.46.29A16.89 16.89 0 0016 26a16.89 16.89 0 008.54-2.16l.46-.29V14l3-1.4V18h2v-7.57zm7 18.51A15.8 15.8 0 0116 24a15.9 15.9 0 01-7-1.59V15l7 3.27L23 15zM16 16L5.36 11 16 6.1l10.64 5z" })));
}
exports.default = SvgTrainingOutline;
//# sourceMappingURL=TrainingOutline.js.map